<div class="notification_request_left">
  <div class="notification_request_text">
    <div class="notification_request_title">
      برای استفاده از تودولیست، وارد حساب کاربری خود شوید.
    </div>
  </div>
  <div class="dismiss_btn" (click)="closeDialog()">
    &times;
  </div>
  <button class="notification_request_button accept-btn" (click)="navigateToLogin()">ورود</button>
</div>
